import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../core/authentication/auth.service';

@Component({
    selector: 'app-handle-sub-domain-redirect',
    templateUrl: './handle-sub-domain-redirect.component.html',
    styleUrls: ['./handle-sub-domain-redirect.component.scss'],
    standalone: false
})
export class HandleSubDomainRedirectComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit() {
    const relayState = this.activatedRoute.snapshot.queryParams.relayState;
    const logOffAsUrl = this.activatedRoute.snapshot.queryParams.redirecturl;
    if (relayState) {
      const redirectUrl = relayState === '/account/login' ? '' : relayState;
      this.authService.handleSubDominLogin('/account/login?redirect=' + redirectUrl);
    } else if (logOffAsUrl) {
      this.router.navigateByUrl(logOffAsUrl);
    }
  }
}
